export default "__VITE_ASSET__2281b363__"